import styled from "styled-components";

import GroupedCombobox from "../GroupedCombobox";

export const Combobox = styled(GroupedCombobox)`
  margin-top: 6px;
`;
